import React, { Component } from 'react';
const Api = require('./Config');

export default class ReviewReport extends Component {
  constructor(props) {
    super(props);
  }

  getReviewPortalUrl() {
    const build = Api.getBuild();
    let url = '';

    if (build == 'LIVE') {
      url = 'https://review.cmdr-ops.com/';
    }
    if (build == 'LOCAL') {
      url = 'http://localhost:8082/';
    }
    if (build == 'STAGE') {
      url = 'https://stage.review.cmdr-ops.com/';
    }
    if (build == 'DEV') {
      url = 'https://dev.review.cmdr-ops.com/';
    }

    return url;
  }

  render() {
    return <iframe src={this.getReviewPortalUrl()} height="1000px" width="100%" frameBorder={0}></iframe>;
  }
}
